
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("g1t9I"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("g1t9I", function(module, exports) {

let $baa35b0c56fa6cdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $baa35b0c56fa6cdc$var$load("h3ABO"),
    $baa35b0c56fa6cdc$var$load("fSobj"),
    $baa35b0c56fa6cdc$var$load("74u2y"),
    $baa35b0c56fa6cdc$var$load("2YffH"),
    $baa35b0c56fa6cdc$var$load("1aTst"),
    $baa35b0c56fa6cdc$var$load("6mHrv"),
    $baa35b0c56fa6cdc$var$load("awWN9"),
    $baa35b0c56fa6cdc$var$load("9CYct"),
    $baa35b0c56fa6cdc$var$load("bLsON"),
    $baa35b0c56fa6cdc$var$load("cPXmn"),
    $baa35b0c56fa6cdc$var$load("hZtKG"),
    $baa35b0c56fa6cdc$var$load("iNmaF"),
    $baa35b0c56fa6cdc$var$load("lVO3w"),
    $baa35b0c56fa6cdc$var$load("hyzoX"),
    $baa35b0c56fa6cdc$var$load("h9Ed7"),
    $baa35b0c56fa6cdc$var$load("eBRUf"),
    $baa35b0c56fa6cdc$var$load("b2zxR"),
    $baa35b0c56fa6cdc$var$load("tKhaz"),
    $baa35b0c56fa6cdc$var$load("g2Huf"),
    $baa35b0c56fa6cdc$var$load("cOwGZ"),
    $baa35b0c56fa6cdc$var$load("cD6Zr"),
    $baa35b0c56fa6cdc$var$load("dtASV"),
    $baa35b0c56fa6cdc$var$load("kWohI"),
    $baa35b0c56fa6cdc$var$load("8YSo7"),
    $baa35b0c56fa6cdc$var$load("g7ggm"),
    $baa35b0c56fa6cdc$var$load("Wowvf"),
    $baa35b0c56fa6cdc$var$load("9S9Mz"),
    $baa35b0c56fa6cdc$var$load("kiGNy"),
    $baa35b0c56fa6cdc$var$load("7do1E"),
    $baa35b0c56fa6cdc$var$load("77dkW"),
    $baa35b0c56fa6cdc$var$load("1MlIV"),
    $baa35b0c56fa6cdc$var$load("g9CVe"),
    $baa35b0c56fa6cdc$var$load("7oiUM"),
    $baa35b0c56fa6cdc$var$load("8t3po"),
    $baa35b0c56fa6cdc$var$load("855o0"),
    $baa35b0c56fa6cdc$var$load("8MfZE"),
    $baa35b0c56fa6cdc$var$load("hv4mn"),
    $baa35b0c56fa6cdc$var$load("dek7I"),
    $baa35b0c56fa6cdc$var$load("dYtBN"),
    $baa35b0c56fa6cdc$var$load("6wr18"),
    $baa35b0c56fa6cdc$var$load("kjZZD"),
    $baa35b0c56fa6cdc$var$load("8iA2F"),
    $baa35b0c56fa6cdc$var$load("4RhJO"),
    $baa35b0c56fa6cdc$var$load("jsqco"),
    $baa35b0c56fa6cdc$var$load("851iy"),
    $baa35b0c56fa6cdc$var$load("37ldp"),
    $baa35b0c56fa6cdc$var$load("ffEVr"),
    $baa35b0c56fa6cdc$var$load("dRpV3"),
    $baa35b0c56fa6cdc$var$load("dTsOE"),
    $baa35b0c56fa6cdc$var$load("hhss7"),
    $baa35b0c56fa6cdc$var$load("jwTn5"),
    $baa35b0c56fa6cdc$var$load("aYdgM"),
    $baa35b0c56fa6cdc$var$load("6u1hm"),
    $baa35b0c56fa6cdc$var$load("klApM"),
    $baa35b0c56fa6cdc$var$load("eQgf0"),
    $baa35b0c56fa6cdc$var$load("8fMw3"),
    $baa35b0c56fa6cdc$var$load("hogcU"),
    $baa35b0c56fa6cdc$var$load("75xVF"),
    $baa35b0c56fa6cdc$var$load("7EorR"),
    $baa35b0c56fa6cdc$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.971d199a.js.map
